import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "familytoday-search" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "search-btn"
}, "search", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "search-toggler-icon" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Search',
  setup(__props) {

const searchToggleElement = ref<HTMLAnchorElement>();
const searchBarElement = ref<HTMLAnchorElement>();
const searchParam = ref("");

const toggleSearchBar = function () {
    searchBarElement.value?.classList.toggle("collapse");
    searchBarElement.value?.classList.toggle("in");
    searchToggleElement.value?.classList.toggle("collapsed");

    if (
        searchToggleElement.value?.hasAttribute("aria-expanded") &&
        searchToggleElement.value?.getAttribute("aria-expanded") == "true"
    ) {
        searchToggleElement.value?.setAttribute("aria-expanded", "false");
    } else {
        searchToggleElement.value?.setAttribute("aria-expanded", "true");
    }
    if (
        searchBarElement.value?.hasAttribute("aria-expanded") &&
        searchBarElement.value?.getAttribute("aria-expanded") == "true"
    ) {
        searchBarElement.value?.setAttribute("aria-expanded", "false");
    } else {
        searchBarElement.value?.setAttribute("aria-expanded", "true");
    }
};
const onSubmit = function () {
    location.href = "/search?q=" + searchParam.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      class: "navbar",
      id: "toggle-search",
      ref_key: "searchBarElement",
      ref: searchBarElement
    }, [
      _createElementVNode("form", {
        name: "search",
        id: "search",
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "q",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParam).value = $event)),
          placeholder: ""
        }, null, 512), [
          [_vModelText, searchParam.value]
        ]),
        _hoisted_3
      ], 40, _hoisted_2),
      _createElementVNode("button", {
        onClick: toggleSearchBar,
        ref_key: "searchToggleElement",
        ref: searchToggleElement,
        class: "search-toggler-icon",
        type: "button",
        "data-toggle": "collapse",
        "data-target": "#toggle-search",
        "aria-controls": "toggle-search",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, _hoisted_5, 512)
    ], 512)
  ]))
}
}

})